import { emptyFromToFilter, emptyVehicleWarningFilter } from "@/constants";
import { ReportFilterType } from "./types";
import { SelectOption } from "@develos/next-components";

export const emptyReportFilter: ReportFilterType = 
{
  vehiclesWarnings: emptyVehicleWarningFilter,
  vehiclesOver35TMode: false,
  categories: [],
  dates: { ...emptyFromToFilter },
  weight: { ...emptyFromToFilter },
  speed: { ...emptyFromToFilter },
  axelsCounts: { ...emptyFromToFilter },
  vehicleRecordsRequest: {
    metricLocalizationUid: '',
    metricPointsUIds: []
  },
  selectedReportType: 0,
  selectedReportFormat: 0,
  selectedAggregationType: null,
  selectedMonth: null,
  selectedYear: null,
  selectedWeekDays: [],
  registrationNumber: ''
};

export const reportFormatsOptions: SelectOption<number>[] = [
  { value: 0, label: 'CSV' },
  { value: 1, label: 'PDF' },
  { value: 2, label: 'XML' }
];

export const reportTypesOptions: SelectOption<number>[] = [
  { value: 0, label: 'Zbiorczy dla kategorii' },
  { value: 1, label: 'Zbiorczy dla liczby pojazdów' },
  { value: 2, label: 'Zbiorczy dla grup wagowych' },
  { value: 3, label: 'Zbiorczy dla średniej prędkości' },
  { value: 4, label: 'Zbiorczy dla przekroczeń prędkości' },
  { value: 5, label: 'Zbiorczy dla maksymalnej prędkości' },
  { value: 6, label: 'Szczegółowy' }
];

export const aggregationTypesOptions: SelectOption<number>[] = [
  { value: 0, label: 'Godzinowo' },
  { value: 1, label: 'Dziennie' },
  { value: 2, label: 'Tygodniowo' },
  { value: 3, label: 'Miesięcznie' },
  { value: 4, label: 'Rocznie' }
];

export const monthsOptions: SelectOption<number>[] = [
  { value: 1, label: 'Styczeń' },
  { value: 2, label: 'Luty' },
  { value: 3, label: 'Marzec' },
  { value: 4, label: 'Kwiecień' },
  { value: 5, label: 'Maj' },
  { value: 6, label: 'Czerwiec' },
  { value: 7, label: 'Lipiec' },
  { value: 8, label: 'Sierpień' },
  { value: 9, label: 'Wrzesień' },
  { value: 10, label: 'Październik' },
  { value: 11, label: 'Listopad' },
  { value: 12, label: 'Grudzień' }
];

export const weekDaysOptions: SelectOption<string>[] = [
  { value: '1', label: 'Poniedziałek' },
  { value: '2', label: 'Wtorek' },
  { value: '3', label: 'Środa' },
  { value: '4', label: 'Czwartek' },
  { value: '5', label: 'Piątek' },
  { value: '6', label: 'Sobota' },
  { value: '0', label: 'Niedziela' }
];

export const yearOptions = (): SelectOption<number>[] => {
  const today = new Date();
  const result: SelectOption<number>[] = [];
  for (let i = 2018; i <= today.getFullYear(); i++) {
    result.push({ label: i.toString(), value: i });
  }
  return result;
}